import apiClient from './client';

export interface SearchResult {
  id: number;
  label: string;
  type: 'job' | 'client' | 'invoice' | 'quote' | 'employee';
  status?: string;
  link: string;
}

export const search = async (q: string): Promise<SearchResult[]> => {
  if (q.length < 2) return [];
  const { data } = await apiClient.get('/search', { params: { q } });
  return data.data;
};
